module.exports = __webpack_public_path__ + "img/link.bd6b392e.svg";